/**
 * Merge or remove the unified list/board `search` query param.
 * @param {Record<string, unknown>} state Current query params.
 * @param {string} value Raw search input.
 * @returns {Record<string, unknown>}
 */
export function applyBoardSearchParams(state, value) {
  const term = String(value ?? "").trim();
  const next = { ...state, offset: 0 };
  if (term) {
    next.search = term;
  } else {
    delete next.search;
  }
  return next;
}
